define('models/messages/comment',["backbone",
 "models/shared/image/image_collection"   
], function (Backbone, ImageCollection) {
    var Comment = Backbone.Model.extend({
        url: function () {
            //var url = pf.accountsURL + "/Posts/" + this.attributes.PGID + "/Comments";
            var url = pf.accountsURL + "/Posts/" + this.attributes.PGID;
            return url;
        },
        initialize: function (options) {
            options = options || {};

            //this.PostID = options.CID;
            this.PostGUID = options.PGID;
            this.ParentPostID = options.PPID;
            this.ParentPostGUID = options.PPGD;
            this.AuthorGUID = options.G;
            this.PostBody = options.PB != null ? unescape(options.PB) : "";
            this.PostTitle = options.PT;
            this.AuthorUserID = options.AUID;
            this.AuthorUser = options.A;
            this.AuthorImage = buildImageURL(pf.enums.entityTypeCodeEnum.User, options.G, pf.enums.imageTypeGUIDEnum.Thumbnail, options.AI);
            this.CreatedDT = options.CDT;
            this.LastUpdatedDT = options.LDT;
            this.RemovedDT = options.RDT;
            this.Flagged = options.F;
            this.CommentImages = new ImageCollection(options.IS, { parse: true });
            this.FlaggedRulingID = options.FRID;
            this.FlaggedRulingType = options.FRT;
            this.FlaggedRulingBy = options.FRB;
            this.FlaggedByUserGUID = options.FBUG;
            this.VideoSourceTypeID = options.VST;
            this.VideoID = options.VID;
        },
        parse: function (data) {
            var response = {};
            response.PostGUID = data.PGID;
            response.ParentPostID = data.PPID;
            response.ParentPostGUID = data.PPGD;
            response.AuthorGUID = data.G;
            response.PostBody = data.PB;
            response.PostTitle = data.PT;
            response.AuthorUserID = data.AUID;
            response.AuthorUser = data.A;
            response.AuthorImage = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.G, pf.enums.imageTypeGUIDEnum.Thumbnail, data.AI);
            response.CreatedDT = data.CDT;
            response.LastUpdatedDT = data.LDT;
            response.RemovedDT = data.RDT;
            response.Flagged = data.F;
            response.CommentImages = new ImageCollection(data.IS, { parse: true });
            response.FlaggedRulingID = data.FRID;
            response.FlaggedRulingType = data.FRT;
            response.FlaggedRulingBy = data.FRB;
            response.FlaggedByUserGUID = data.FBUG;
            response.VideoSourceTypeID = data.VST;
            response.VideoID = data.VID;

            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            this.Count = options.Count;

            var data = {};
            //data.CID = attributes.PostID;
            data.PPID = attributes.ParentPostID;
            data.PPGD = attributes.ParentPostGUID;
            data.G = attributes.AuthorGUID;
            data.PB = attributes.PostBody;
            data.PT = attributes.PostTitle;
            data.AUID = attributes.AuthorUserID;
            data.A = attributes.AuthorUser;
            data.CDT = attributes.CreatedDT;
            data.LDT = attributes.LastUpdatedDT;
            data.RDT = attributes.RemovedDT;
            data.F = attributes.Flagged;
           // data.IS = this.model.attributes.CommentImages;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, this.attributes, options);
        }
    });

    return Comment;
});


